import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TableResponse } from '../../models/table-response';
import { TableRequestData } from '../../models/table/table-request-param';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  Regulamin,
  RegulaminEditRequestBody,
  RegulaminHistory,
  RegulaminRequestBody,
} from '../../models/regulamin';
import { HttpUtils } from '../../utils/http.utils';

@Injectable({ providedIn: 'root' })
export class RulesApi {
  #httpClient: HttpClient = inject(HttpClient);
  readonly #apiUrl = environment.API_EWNIOSKI + '/admin/regulaminy';

  public getRules$(
    tableRequest: TableRequestData,
  ): Observable<TableResponse<Regulamin>> {
    return this.#httpClient.get<TableResponse<Regulamin>>(`${this.#apiUrl}`, {
      params: HttpUtils.toHttpParams(tableRequest),
      withCredentials: true,
    });
  }

  public getRuleById$(ruleId: number): Observable<Regulamin> {
    return this.#httpClient.get<Regulamin>(`${this.#apiUrl}/${ruleId}`, {
      withCredentials: true,
    });
  }

  public createRule$(
    ruleRequestBody: RegulaminRequestBody,
  ): Observable<Regulamin> {
    return this.#httpClient.post<Regulamin>(
      `${this.#apiUrl}`,
      ruleRequestBody,
      {
        withCredentials: true,
      },
    );
  }

  public updateRule$(
    ruleId: number,
    ruleRequestBody: RegulaminEditRequestBody,
  ): Observable<Regulamin> {
    return this.#httpClient.put<Regulamin>(
      `${this.#apiUrl}/${ruleId}`,
      ruleRequestBody,
      {
        withCredentials: true,
      },
    );
  }

  public deleteRule$(ruleId: number): Observable<void> {
    return this.#httpClient.delete<void>(`${this.#apiUrl}/${ruleId}`, {
      withCredentials: true,
    });
  }

  public getRuleHistory$(
    tableRequest: TableRequestData,
    ruleId: number | null,
  ): Observable<TableResponse<RegulaminHistory>> {
    return this.#httpClient.get<TableResponse<RegulaminHistory>>(
      `${this.#apiUrl}/${ruleId}/historia`,
      {
        params: HttpUtils.toHttpParams(tableRequest),
        withCredentials: true,
      },
    );
  }
}
